import React from "react";

const FacebookSocialIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7607 10.699L13.0913 8.54369H11.0233V7.14501C11.0233 6.55534 11.3121 5.98058 12.2384 5.98058H13.1786V4.14563C13.1786 4.14563 12.3253 4 11.5096 4C9.80637 4 8.69319 5.03223 8.69319 6.90097V8.54369H6.79999V10.699H8.69319V15.9094C9.07281 15.969 9.46189 16 9.85824 16C10.2546 16 10.6437 15.969 11.0233 15.9094V10.699H12.7607Z",
  fill: "#1877F2"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(FacebookSocialIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;